import {getNextQuiz} from "../services/quizService";
/**
 * Get next quiz list
 * @param selectedExamId
 * @returns {Function}
 */
export const getNextQuizList = (selectedExamId) => dispatch => {
    getNextQuiz(selectedExamId).then((response) => {
            // handle success
            dispatch( {
                type: 'GET_NEXT_QUIZ_LIST_SUCCESS',
                payload: response
            });
        })
        .catch((error) => {
            // handle error
            dispatch({
                type: 'GET_NEXT_QUIZ_LIST_ERROR',
                payload: []
            });
        })

};
